// extracted by css-extract-rspack-plugin
var _1 = "Z4AeN";
export { _1 as "container" }
